export const COUNTER_MAP = {
  task_restyle: 'walstreet_restyle_doorlooptijd_counter',
  task_spot_repair: 'walstreet_spotrepair_doorlooptijd_counter',
  task_adjust: 'walstreet_bijwerken_doorlooptijd_counter',
  task_interior_polish: 'walstreet_poetsen_interieur_doorlooptijd_counter',
  task_polish_exterior: 'walstreet_poetsen_exterieur_doorlooptijd_counter',
  task_spray: 'walstreet_spuiten_doorlooptijd_counter',
  task_int_ext_polish: 'walstreet_poetsen_in_en_exterieur_doorlooptijd_counter',
  task_desticker: 'walstreet_ontstickeren_doorlooptijd_counter',
  task_window_repair: 'walstreet_ruitreparatie_doorlooptijd_counter',
  task_attach_parts: 'walstreet_monteren_onderdelen_doorlooptijd_counter',
  task_interior_repair: 'walstreet_interior_repair_doorlooptijd_counter',
  task_nijboer: 'walstreet_nijboer_doorlooptijd_counter',
  task_AVN: 'walstreet_avn_doorlooptijd_counter',
  task_repair: 'walstreet_repair_doorlooptijd_counter',
  task_apk: 'walstreet_apk_doorlooptijd_counter',
  task_service: 'walstreet_service_doorlooptijd_counter',
  task_recall: 'walstreet_recall_doorlooptijd_counter',
};
